import { render, staticRenderFns } from "./EmptyStateTable.vue?vue&type=template&id=4e83f475&scoped=true&"
import script from "./EmptyStateTable.vue?vue&type=script&lang=ts&"
export * from "./EmptyStateTable.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyStateTable.vue?vue&type=style&index=0&id=4e83f475&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83f475",
  null
  
)

export default component.exports